import React from 'react';
import { Link } from 'react-router-dom';

const Error: React.FC<{ title?: string; description?: string }> = ({
    title = 'Page not found',
    description = 'This page is unavailable. Find your next read or experiment below.',
}) => (
    <main id="main" tabIndex={-1} className="bs-page bs-shell" style={{ minHeight: '70vh', paddingTop: 'clamp(48px, 8vw, 96px)', paddingBottom: 64 }}>
        <h1 className="bs-display">{title}</h1>
        <p className="bs-lede" style={{ margin: '24px 0 32px', maxWidth: '48ch' }}>{description}</p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24 }}>
            <Link className="bs-btn bs-btn--accent" to="/">Go home</Link>
            <Link className="bs-btn" to="/articles">Read articles</Link>
            <Link className="bs-btn" to="/labs">Browse labs</Link>
        </div>
    </main>
);

export default Error;
